import { resetDb } from '../../hooks/useDexieDB'

import Select from './Select'
import Upload from './Upload'

interface Props {
  codesUploaded: boolean
  codesAccepted: number
  setCodesUploaded: Function
  setCodesAccepted: Function
}

export default function CompanySelect ({ codesUploaded = false, codesAccepted, setCodesUploaded, setCodesAccepted }: Props): JSX.Element {
  async function onReset (): Promise<void> {
    setCodesAccepted([])
    setCodesUploaded(false)
    await resetDb()
  }

  if (!codesUploaded) {
    return (
      <Upload
        setCodesAccepted={function (count: number) { setCodesAccepted(count) }}
        setCodesUploaded={function (value: boolean) { setCodesUploaded(value) }}
      />
    )
  } else {
    return (
      <Select
        codesAccepted={codesAccepted}
        onReset={async function () { await onReset() }}
        setCodesAccepted={function (count: number) { setCodesAccepted(count) }}
      />
    )
  }
}
